import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=d58c1320&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=d58c1320&prod&lang=scss&scoped=true&"
import style1 from "./Main.vue?vue&type=style&index=1&id=d58c1320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58c1320",
  null
  
)

export default component.exports